import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import{ GlobalConstants } from '../common/global-constants';
const apiUrl = GlobalConstants.apiURL
@Injectable({
  providedIn: 'root'
})
export class RetailService {

  constructor(private http:HttpClient, private sharedapi:SharedService) { }

  getRetailLeadsForsheetview(pageno:number,limit:number,qString:string)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-retail-lead-lists/'+limit+'/'+pageno+'?'+qString,{headers:webheader})
  }

  UpdateRetailLeadsFromSheetview(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.put(apiUrl+'update-retail-lead-sheetview',data,{headers:webheader})
  }
}
